import { render, staticRenderFns } from "./IconOrdemMissao.vue?vue&type=template&id=820f794e"
import script from "./IconOrdemMissao.vue?vue&type=script&lang=js"
export * from "./IconOrdemMissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports